<template>
    <div>
    <Nav/>
    <div>
      <div>
      <div class="flex justify-between pl-3 pr-3 mt-2 border-b-2 pb-3">
          
          <div class="border-2 rounded-md px-2 py-1">
              Sofa
          </div>
          <div class="border-2 rounded-md px-2 py-1">
              Table
          </div>
          <div class="border-2 rounded-md px-2 py-1">
              Storage Rack
          </div>
          <div class="border-2 rounded-md px-2 py-1">
              Bean Bag Chair
          </div>
          <div class="border-2 rounded-md px-2 py-1">
              Pads
          </div>
      </div>
      <div class="mt-2">
          <p class="text-xs pl-3 font-bold text-gray-400">Price and other details may vary based on the product size and color</p>
      </div>
      <div class="ml-5 mr-5 mt-5 mb-5 shadow-md pb-5 pl-2 pr-2">
        <a href="">
            <img src="/bottomcard30.jpg" alt="">
            <p class="mt-3 text-sm font-semibold">Premium Arabic Sofa Set,Floor Cushions,Seating Cushions,Moroccan Sofas,Arabic Majils,Living Room Sectionals... </p>
            <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300 w-80 ml-5">Add to Cart</button>
              </div>
        </a>

      </div>
      <div class="ml-5 mr-5 mt-5 mb-5 shadow-md pb-5 pl-2 pr-2">
        <a href="">
            <img src="/bottomcard30.jpg" alt="">
            <p class="mt-3 text-sm font-semibold">Premium Arabic Sofa Set,Floor Cushions,Seating Cushions,Moroccan Sofas,Arabic Majils,Living Room Sectionals... </p>
            <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300 w-80 ml-5">Add to Cart</button>
              </div>
        </a>

      </div>
      <div class="ml-5 mr-5 mt-5 mb-5 shadow-md pb-5 pl-2 pr-2">
        <a href="">
            <img src="/bottomcard30.jpg" alt="">
            <p class="mt-3 text-sm font-semibold">Premium Arabic Sofa Set,Floor Cushions,Seating Cushions,Moroccan Sofas,Arabic Majils,Living Room Sectionals... </p>
            <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300 w-80 ml-5">Add to Cart</button>
              </div>
        </a>

      </div>
      <div class="ml-5 mr-5 mt-5 mb-5 shadow-md pb-5 pl-2 pr-2">
        <a href="">
            <img src="/bottomcard30.jpg" alt="">
            <p class="mt-3 text-sm font-semibold">Premium Arabic Sofa Set,Floor Cushions,Seating Cushions,Moroccan Sofas,Arabic Majils,Living Room Sectionals... </p>
            <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300 w-80 ml-5">Add to Cart</button>
              </div>
        </a>

      </div>
      <div class="ml-5 mr-5 mt-5 mb-5 shadow-md pb-5 pl-2 pr-2">
        <a href="">
            <img src="/bottomcard30.jpg" alt="">
            <p class="mt-3 text-sm font-semibold">Premium Arabic Sofa Set,Floor Cushions,Seating Cushions,Moroccan Sofas,Arabic Majils,Living Room Sectionals... </p>
            <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300 w-80 ml-5">Add to Cart</button>
              </div>
        </a>

      </div>
      <div class="ml-5 mr-5 mt-5 mb-5 shadow-md pb-5 pl-2 pr-2">
        <a href="">
            <img src="/bottomcard30.jpg" alt="">
            <p class="mt-3 text-sm font-semibold">Premium Arabic Sofa Set,Floor Cushions,Seating Cushions,Moroccan Sofas,Arabic Majils,Living Room Sectionals... </p>
            <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300 w-80 ml-5">Add to Cart</button>
              </div>
        </a>

      </div>
      <div class="ml-5 mr-5 mt-5 mb-5 shadow-md pb-5 pl-2 pr-2">
        <a href="">
            <img src="/bottomcard30.jpg" alt="">
            <p class="mt-3 text-sm font-semibold">Premium Arabic Sofa Set,Floor Cushions,Seating Cushions,Moroccan Sofas,Arabic Majils,Living Room Sectionals... </p>
            <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300 w-80 ml-5">Add to Cart</button>
              </div>
        </a>

      </div>
      <div class="ml-5 mr-5 mt-5 mb-5 shadow-md pb-5 pl-2 pr-2">
        <a href="">
            <img src="/bottomcard30.jpg" alt="">
            <p class="mt-3 text-sm font-semibold">Premium Arabic Sofa Set,Floor Cushions,Seating Cushions,Moroccan Sofas,Arabic Majils,Living Room Sectionals... </p>
            <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300 w-80 ml-5">Add to Cart</button>
              </div>
        </a>

      </div>
      <div class="ml-5 mr-5 mt-5 mb-5 shadow-md pb-5 pl-2 pr-2">
        <a href="">
            <img src="/bottomcard30.jpg" alt="">
            <p class="mt-3 text-sm font-semibold">Premium Arabic Sofa Set,Floor Cushions,Seating Cushions,Moroccan Sofas,Arabic Majils,Living Room Sectionals... </p>
            <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300 w-80 ml-5">Add to Cart</button>
              </div>
        </a>

      </div>
      <div class="ml-5 mr-5 mt-5 mb-5 shadow-md pb-5 pl-2 pr-2">
        <a href="">
            <img src="/bottomcard30.jpg" alt="">
            <p class="mt-3 text-sm font-semibold">Premium Arabic Sofa Set,Floor Cushions,Seating Cushions,Moroccan Sofas,Arabic Majils,Living Room Sectionals... </p>
            <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300 w-80 ml-5">Add to Cart</button>
              </div>
        </a>

      </div>
      <div class="ml-5 mr-5 mt-5 mb-5 shadow-md pb-5 pl-2 pr-2">
        <a href="">
            <img src="/bottomcard30.jpg" alt="">
            <p class="mt-3 text-sm font-semibold">Premium Arabic Sofa Set,Floor Cushions,Seating Cushions,Moroccan Sofas,Arabic Majils,Living Room Sectionals... </p>
            <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300 w-80 ml-5">Add to Cart</button>
              </div>
        </a>

      </div>
   
        <div class="bg-gray-800 flex pt-3 text-white pl-5 pb-6">
  <div>
    <div><a href="">Amazon.com</a></div>
    <div class="mt-5"><a href="">Your Lists</a></div>
    <div class="mt-5"><a href="">Registory & Gift List</a></div>
    <div class="mt-5"><a href="">Your Account</a></div>
    <div class="mt-5"><a href="">Sell Products on Amazon</a></div>
    <div class="mt-5"><a href="">Recalls and Product Safety <br> Alerts</a></div>
    <div class="mt-5"><a href="">Customer Service</a></div>
  
  </div>
  <div class="ml-5">
    <div><a href="">Your Orders</a></div>
    <div class="mt-5"><a href="">Gift Cards</a></div>
    <div class="mt-5"><a href="">Find a Gift</a></div>
    <div class="mt-5"><a href="">Browsing History</a></div>
    <div class="mt-5"><a href="">Your Returns</a></div>
  </div>
        </div>
        <div class="bg-gray-900 text-white pt-10 pb-10">
  <div class="flex ml-8">
  <div class="text-sm"><i class="fa-solid fa-globe"></i> English</div>
  <div class="text-sm ml-7">$ USD - US. Dollar</div>
  <div class="text-sm ml-7"><img src="/united.jpg" alt="" class="w-6 h-4 inline-block"> United States</div>
  </div>
  <div class="mt-10">
  <div class="text-center">
    Already a customer? <a href="">Sign in</a>
  </div>
  <div class="mt-5 flex text-xs ml-1 mr-1">
  <div><a href="" class="w-80">Conditions of Use</a></div>
  <div><a href="" class="ml-3">Privacy Notice</a></div>
  <div><a href="" class="ml-3">Consumer Health Data Privacy Disclosure</a></div>
  </div>
  <div class="text-center text-xs">Your Ads Privacy Choices <input type="checkbox" class="mt-2 ml-2"></div>
  <div class="text-center text-xs mt-3">&copy;1996-2024, Amazon.com, Inc. or its affiliates</div>
  </div>
        </div>
       </div>
    </div>
  </div>
  
 
  </template>
  
  <script>
  import Nav from '@/components/Nav.vue'
  export default {
  components:{
      Nav
  }
  }
  </script>
  
  <style>
  
  </style>